import { Flex, Input, Table } from '@mantine/core';
import type { PropsWithChildren } from 'react';
import { memo } from 'react';

import classes from './list.module.css';

type Props = PropsWithChildren<{
	label: string;
	hidden?: boolean;
	htmlFor?: string;
	allowWrap?: boolean;
	column?: boolean;
}>;

export const ListItem = memo(_ListItem);
ListItem.displayName = 'ListItem';

function _ListItem({
	label,
	hidden = false,
	htmlFor,
	allowWrap = false,
	column = false,
	children,
}: Props) {
	return (
		<Table.Tr className={classes.item} hidden={hidden}>
			<Table.Td>
				<Flex
					direction={column ? 'column' : 'row'}
					wrap='nowrap'
					align={column ? 'flex-start' : 'center'}
					gap={column ? 2 : 'xs'}
					justify='space-between'
					w='100%'
				>
					<Input.Label
						styles={{ label: { textWrap: allowWrap ? 'wrap' : 'nowrap' } }}
						htmlFor={htmlFor}
					>
						{label}
					</Input.Label>
					<Flex
						flex={1}
						justify={column ? 'flex-start' : 'flex-end'}
						w={column ? '100%' : undefined}
					>
						{children}
					</Flex>
				</Flex>
			</Table.Td>
		</Table.Tr>
	);
}
